export const PAGE_PATHS = {
  CART: '/cart',
  CHECKOUT_PAYMENT: '/checkout/payment',
  PAYMENT_CONFIRMATION: '/checkout/confirmation',
}
